import { MANAGE_PERMISSIONS } from "../services";
import fetchApi from "../utilityFunctions/customCreateApi2";

export const fetchManagePermission = async ({ query = {} }) => {
  const endpoint = MANAGE_PERMISSIONS?.FETCH_DATA || "";
  return await fetchApi({ endpoint, query });
};
export const addUpdateManagePermission = async ({ body = {} }) => {
  const endpoint = MANAGE_PERMISSIONS?.ADD_UPDATE_PERMISSION || "";
  return await fetchApi({ endpoint, body });
};
export const addUpdateGroup = async ({ body = {} }) => {
  const endpoint = MANAGE_PERMISSIONS?.ADD_UPDATE_GROUP || "";
  return await fetchApi({ endpoint, body });
};
export const grantPermission = async ({ body = {} }) => {
  const endpoint = MANAGE_PERMISSIONS?.GRANT_PERMISSION || "";
  return await fetchApi({ endpoint, body });
};
export const deleteGroup = async ({ body = {} }) => {
  const endpoint = MANAGE_PERMISSIONS?.DELETE_GROUP || "";
  return await fetchApi({ endpoint, body });
};
export const deletePermission = async ({ body = {} }) => {
  const endpoint = MANAGE_PERMISSIONS?.DELETE_PERMISSION || "";
  return await fetchApi({ endpoint, body });
};
export const deleteGroupPermission = async ({ body = {} }) => {
  const endpoint = MANAGE_PERMISSIONS?.DELETE_GROUP_PERMISSION || "";
  return await fetchApi({ endpoint, body });
};

export const fetchManagePermissionGroup = async ({ query = {} }) => {
  const endpoint = MANAGE_PERMISSIONS?.GET_GROUP_PERMISSION || "";
  return await fetchApi({ endpoint, query });
};

export const addGroupMember = async ({ body = {} }) => {
  const endpoint = MANAGE_PERMISSIONS?.ADD_GROUP_PERMISSION_MEMBER || "";
  return await fetchApi({ endpoint, body });
};

export const deleteGroupMember = async ({ body = {} }) => {
  const endpoint = MANAGE_PERMISSIONS?.DELETE_GROUP_PERMISSION_MEMBER || "";
  return await fetchApi({ endpoint, body });
};

export const addUpdateGroupMember = async ({ body = {} }) => {
  const endpoint = MANAGE_PERMISSIONS?.ADD_UPDATE_GROUP_PERMISSION || "";
  return await fetchApi({ endpoint, body });
};
